import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { CollapsibleImportSummary } from '../../../components/CollapsibleSummary';
import { IImportImageSetRejection, ImportImageSetRejectionReason } from '../projects.model';

interface IProps {
  isLastSummaryItem?: boolean;
  isPanelOpen: boolean;
  handlePanelToggle: () => void;
  rejectedImageSets: IImportImageSetRejection[];
  importedImageSetsCount: number;
  skippedImageSetsCount: number;
}

export const ImportImageSetsSummary = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  const mapImageSetRejectionReason = (reason: ImportImageSetRejectionReason): string => {
    switch (reason) {
      case ImportImageSetRejectionReason.DATASET_NOT_FOUND:
        return t('dataset_not_found_in_workspace');
      case ImportImageSetRejectionReason.IMAGE_NOT_FOUND:
        return t('image_not_found_in_dataset');
      case ImportImageSetRejectionReason.IMAGE_DUPLICATED:
        return t('image_duplicated');
      case ImportImageSetRejectionReason.INVALID_SET_TYPE:
        return t('invalid_set_type');
      default:
        return t('unknown');
    }
  };

  const getRejectionReasons = (): string[] => {
    return props.rejectedImageSets.map((x) => {
      return `${x.datasetName} - ${x.imageName} - ${mapImageSetRejectionReason(x.reason)}`;
    });
  };

  return (
    <CollapsibleImportSummary
      importedItemsCount={props.importedImageSetsCount}
      skippedItemsCount={props.skippedImageSetsCount}
      rejectionReasons={getRejectionReasons()}
      isPanelOpen={props.isPanelOpen}
      togglePanel={props.handlePanelToggle}
      isLastSummaryItem={props.isLastSummaryItem}
      importedMessage={t('sets_imported', { count: props.importedImageSetsCount })}
      skippedMessage={t('sets_skipped', { count: props.skippedImageSetsCount })}
    />
  );
});
